<template>
  <div class="chart" ref="chartdiv" style="height: 300px;">
  </div>
</template>
<style itemscope>
  .chart{
    width: 100%;
    height: 500px;
  }
</style>
<script>
  import moment from 'moment';
  import * as am4core from "@amcharts/amcharts4/core";
  import * as am4charts from "@amcharts/amcharts4/charts";
  import am4themes_animated from "@amcharts/amcharts4/themes/animated";

  am4core.useTheme(am4themes_animated);

  export default {
    name: 'LollipopChart',
    props : {
      data : {
        type : Array,
        required : false
      },
      label :{
        type: String,
        required: true
      },
      color :{
        type: String,
        required: false
      }
    },
    data(){
      return {
        chart : null
      }
    },
    watch : {
      data(newVal, oldVal){
        if(this.chart){
          this.chart.data = newVal;
        }
      }
    },
    mounted() {

      am4core.useTheme(am4themes_animated);

      let chart = am4core.create(this.$refs.chartdiv, am4charts.XYChart);
      chart.responsive.enabled = true;

    // Add data
      chart.data = this.data;

      let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
      dateAxis.renderer.minGridDistance = 50;

      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

      let series = chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueY = this.label;
      series.dataFields.dateX = "date";
      series.tooltipText = "{valueY}";
      series.tooltip.background.cornerRadius = 20;
      series.tooltip.background.fillOpacity = 0.5;
      series.tooltip.label.padding(12,12,12,12)

      series.fillOpacity = 0;
      series.strokeOpacity = 1;
      series.strokeDashArray = "1,3";
      series.columns.template.width = 0.01;
      series.tooltip.pointerOrientation = "horizontal";
      series.stroke = am4core.color(this.color ? this.color : "rgb(115, 103, 240)");

      let bullet = series.bullets.create(am4charts.CircleBullet);
      bullet.circle.fill = am4core.color(this.color ? this.color : "rgb(115, 103, 240)");

      // Add cursor
      chart.cursor = new am4charts.XYCursor();
      chart.cursor.xAxis = dateAxis;
      chart.cursor.snapToSeries = series;


      this.chart = chart;
    },
    beforeDestroy() {
      if (this.chart) {
        this.chart.dispose();
      }
    }
  }
</script>
